export default __webpack_public_path__ + "static/media/1.8f7fa124.png";